import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as config from '../config';
import LoginForm from '@components/LoginForm';
import { login } from '@features/account/accountSlice';
import styles from '@styles/LoginPage.module.scss';
import { useLocation } from 'react-router';
import { DevMode } from '../utils/utils';
import { DynamicIcon, DynamicTitle, ThirdPartyDomain } from '../utils/domain';
import { useSearchParams } from 'react-router';
import Footer from '@components/Footer';
import LoginBg from '@assets/login_image.png';

function LoginPage() {
    const dispatch = useDispatch();
    const [username, setUsername] = useState('');
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        //if this page is opened with query
        const searchParams = new URLSearchParams(location.search);
        const v = searchParams.get('v');
        // console.log(v);
        setUsername(v);
        DynamicIcon();
        DynamicTitle();
    }, []);

    const submit = (data) => {
        return dispatch(login(data)).then((res) => {
            // console.log(res);
            return res;
        });
    };

    const title = () => {
        const params = new URLSearchParams(searchParams);
        const channel = params.get('channel');
        if (
            window.location.host.includes(ThirdPartyDomain.Globalticket_com_cn) ||
            channel == ThirdPartyDomain.Globalticket_com_cn
        ) {
            return (
                <img
                    src={`https://agency.aoholiday.com.au/public/logo?whiteLabelDomain=${ThirdPartyDomain.Globalticket_com_cn}`}
                />
            );
        }
        return 'Agent Portal';
    };

    return (
        <div className={styles.container}>
            <div className={styles.leading_container}>
                <div className={styles.image_container}>
                    <img src={LoginBg} />
                </div>
                <div className={styles.description_container}>
                    <h3 className={styles.title}>AO Holiday是一个连接代理商和运营商的旅游平台</h3>
                    <p>核心价值观就是尽量减少工作量，尽量提升结果</p>
                </div>
            </div>
            <div className={styles.trailing_container}>
                <div className={styles.logo_container}>
                    <img src={`${config.baseURL}/favicon/logo.svg`} />
                </div>
                <div className={styles.login_container}>
                    <div className={styles.title}>{title()}</div>
                    <LoginForm submit={submit} username={username} />
                    <div>
                        <p>If you are not a registered user, please contact your Sales Manager for your login.</p>
                        <p>如果您不是注册用户，请联系您的销售经理进行登录。</p>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}

LoginPage.propTypes = {};

export default LoginPage;
